import React, {Component} from "react";
import "../ChoiceRayon/Choice.css"
import mar from "../../Image/mariupol.png"
import vol from "../../Image/volnovaha-rayon.png"
import pok from "../../Image/pokr.png"
import kram from "../../Image/kram.png"
import buxm from "../../Image/buxm.png"
import MainList from "../ListMain/MainList";
import Okup from "../ListMain/Okup";
import {Button} from "react-bootstrap";
import Flippy, {BackSide, FrontSide} from "react-flippy/dist/index.esm";
import {Hexagon, ResponsiveHoneycomb} from "react-honeycomb";

export default class ChoiceButton extends Component {

    constructor(props) {
        super(props)
        this.state = {
            moduls: [
                {
                    title: 'Переглянути товари/послуги по Маріупольському району',
                    image: mar,
                    id_rayon: "UA14140000000070889"
                },
                {
                    title: "Переглянути товари/послуги по Волноваському району",
                    image: vol,
                    id_rayon: "UA14040000000098211"
                },
                {
                    title: "Переглянути товари/послуги по Покровському району",
                    image: pok,
                    id_rayon: "UA14160000000061982"
                },
                {
                    title: "Переглянути товари/послуги по Краматорському району",
                    image: kram,
                    id_rayon: "UA14120000000070232"
                },
                {
                    title: 'Переглянути товари/послуги по Бахмутському району',
                    image: buxm,
                    id_rayon: "UA14020000000013572"
                },

            ],
            idrayon: "",
            showModuls: true,
            okup: false,
            width: 0,
            height: 0,
            isFlipped: false
        }
        this.handleClick = this.handleClick.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        this.setState(prevState => ({isFlipped: !prevState.isFlipped}));
    }

    choiceModulesHandler = (id) => {
        this.setState({
            showBack: true,
            idrayon: id,
            okup: id == "UA14100000000010319" || id == "UA14080000000098686" || id == "UA14060000000024357" ? true : false,
            showModuls: false,

        })
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({width: window.innerWidth, height: window.innerHeight});
    }

    render() {
        const show = this.state.showModuls;
        const okup = this.state.okup;
        let moduls = null
        //  console.log(this.state.width)
        const sideLength = this.state.width < 768 ? 150 : 200
        //this.state.width / 10;
        //  console.log(sideLength)
        if (this.state.showModuls) {
            moduls = this.state.moduls.map((moduls, index) => {
                return (
                    <Flippy
                        flipOnHover={true} // default false
                        flipOnClick={false} // default false
                        flipDirection="horizontal" // horizontal or vertical
                        ref={(r) => this.flippy = r} // to use toggle method like this.flippy.toggle()
                        style={{
                            // clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",

                        }}
                    >
                        <FrontSide
                            style={{
                                //clipPath: "polygon(50% 0%, 100% 20%, 100% 75%, 50% 100%, 0% 75%, 0% 20%)",
                                // backgroundColor: 'rgba(143,134,134,0.25)',
                                padding: "4rem",// border: "1px solid #171717FF !important"
                            }}
                        >
                            <img src={moduls.image} alt=""
                                 style={{
                                     // marginLeft: "10%",
                                     //marginRight: "10%",
                                     width: "100%",
                                     height: "100%",
                                     marginTop: "15%",
                                     marginBottom: "25%"
                                 }}/>
                        </FrontSide>
                        <BackSide
                            style={{
                                // backgroundColor: '#f6f6f6',
                                //clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                            }}>
                            <h4 className="card-title">{moduls.title}</h4>
                            <Button onClick={this.choiceModulesHandler.bind(this, moduls.id_rayon)}
                                    className="btn choice">Переглянути
                            </Button>
                        </BackSide>
                    </Flippy>


                    /* <Card>
                         <img src={moduls.image} className="col-md-4" alt=""
                              style={{
                                  width: "10vw",
                                  height: "20hv"
                              }}/>
                         <div className="col">
                             <div className="card-block px-2">
                                 <h4 className="card-title">{moduls.title}</h4>
                                 <Button onClick={this.choiceModulesHandler.bind(this, moduls.id_rayon)}
                                         className="btn">Переглянути
                                 </Button>
                             </div>
                         </div>
                     </Card>*/
                )
            })
        }

        return (
            <div style={{
                // backgroundColor: "#FFF4D0",
                height: "100vh"
            }}>

                {show ? <div>

                    <ResponsiveHoneycomb
                        defaultWidth={1024}
                        size={sideLength}
                        items={moduls}
                        style={{
                            boxShadow: "10px 5px 5px black",

                        }}
                        renderItem={(item) => (
                            console.log(item),
                                <Hexagon className="hexagonout">
                                    <Hexagon className="hexagon">
                                        {item}
                                    </Hexagon>
                                </Hexagon>
                        )}
                    />


                </div> : okup ? <Okup/> : <MainList iddata={this.state.idrayon}/>

                }
            </div>
        );

    }
}
